<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="col-sm-4 p-0 pull-left">
        <h3>Panel łączenia Influencerów</h3>
      </div>
      <div class="col-sm-4 p-0 pull-right text-right">
        <label>Categoria: </label>
        <select v-model="filter.category_id">
          <option v-for="(c, id) in category" v-bind:value="id">{{c}}</option>
        </select>
      </div>
    </div>
    <div v-for="(influencer, influencerIdx) in influencers" class="col-sm-12 m-t-20">
      <div class="panel panel-default">
        <div class="panel-heading">
          <div class="pull-left">
            <h4>{{ influencer.influencer.name }}</h4>
          </div>
          <div class="pull-right hover m-t-10">
            <span v-on:click="setStatus(1, influencer.influencer.id)">Zapisz Influencera</span>
            <span v-on:click="setStatus(1, influencer.influencer.id)" class="glyphicon glyphicon-check" title="Zapisz Influencera">

            </span>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="panel-body">
          <h4>Podstawowe informacje o Influencerze zebrane przez zespół Monitori:</h4>
          <div class="col-xs-6 p-0">
            <table class="table table-striped">
              <tr>
                <th>ID</th>
                <td>{{influencer.influencer.id}}</td>
              </tr>
              <tr>
                <th>Name</th>
                <td>{{ influencer.influencer.name }}</td>
              </tr>
              <tr>
                <th>Categoria</th>
                <td>{{ category[influencer.influencer.category_id] }}</td>
              </tr>
              <tr>
                <th>Strona</th>
                <td>{{ influencer.influencer.site }}</td>
              </tr>
              <tr>
                <th>Imię</th>
                <td>{{ influencer.influencer.firstname }}</td>
              </tr>

              <tr>
                <th>Nazwisko</th>
                <td>{{ influencer.influencer.lastname }}</td>
              </tr>
              <tr>
                <th>Nick</th>
                <td>{{ influencer.influencer.nickname }}</td>
              </tr>
            </table>
          </div>
          <div class="clearfix"></div>

          <h5>Autorzy Influencera:</h5>
          <table class="table table-bordered">
            <thead>
            <tr>
              <td>#</td>
              <td>Avatar</td>
              <td>Link</td>
              <td></td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(author, authorIdx) in influencer.authors" v-bind:class="author.status == 2? 'danger' : ''">
              <td>{{ authorIdx + 1 }}</td>
              <td><img height="50px" v-bind:src="author.picture"></td>
              <td><a v-bind:href="author.url" target="_blank">{{ author.url }}</a></td>
              <td class="text-center">
                <a v-on:click="setAuthorStatus(author.id, author.authorId, author.influencerId, authorIdx, influencerIdx, 1)" v-if="author.status == 2"><span class="glyphicon glyphicon-ok" title="Zatwierdź"></span></a>
                <a v-on:click="setAuthorStatus(author.id, author.authorId, author.influencerId, authorIdx, influencerIdx, 2)" v-if="author.status != 2"><span class="glyphicon glyphicon-remove" title="Usuń"></span></a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="panel-body border-top">
          <h4>Dane hash.fm</h4>
          <h5>Influencerzy podobni</h5>
          <div class="col-sm-12" style="padding: 0;">
            <div v-for="(infHash, infHashIdx) in influencer.influencerConnected" class="col-sm-6"  style="padding-left: 0;">
              <div class="col-sm-12 p-0" v-if="infHash.influencer.status != 2">
                <h5>Podstawowe dane:
                  <span class="pull-right hover" title="Set similar influencer">
                    <span>Scal Influencera</span>
                    <span v-on:click="setSimilarInfluencer(influencer.influencer.id, infHash.influencer.id, influencerIdx, infHashIdx)" class="glyphicon glyphicon-off"></span>
                  </span>
                </h5>
                <table class="table table-striped">
                  <tr>
                    <th>ID</th>
                    <td>{{ infHash.influencer.id }}</td>
                  </tr>
                  <tr>
                    <th>Status</th>
                    <td>{{infHash.influencer.status}}</td>
                  </tr>
                  <tr>
                    <th>Name</th>
                    <td>{{ infHash.influencer.name }}</td>
                  </tr>
                  <tr>
                    <th>Kategoria</th>
                    <td>{{ infHash.influencer.category_id }}</td>
                  </tr>
                  <tr>
                    <th>Strona</th>
                    <td>{{ infHash.influencer.site }}</td>
                  </tr>
                  <tr>
                    <th>Imię</th>
                    <td>{{ infHash.influencer.firstname }}</td>
                  </tr>
                  <tr>
                    <th>Nazwisko</th>
                    <td>{{ infHash.influencer.lastname }}</td>
                  </tr>
                  <tr>
                    <th>Nick</th>
                    <td>{{ infHash.influencer.nickname }}</td>
                  </tr>
                  <tr>
                    <th>Additional info</th>
                    <td>{{ infHash.influencer.location }}</td>
                  </tr>
                </table>
                <h5>Autorzy Influencera:</h5>
                <table class="table table-bordered">
                  <thead>
                  <tr>
                    <td>#</td>
                    <td>Avatar</td>
                    <td>Link</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(authorHash, $index) in infHash.authors" v-bind:class="authorHash.status?'success':'danger'">
                    <td>{{ $index }}</td>
                    <td><img height="50px" v-bind:src="authorHash.author.picture"></td>
                    <td><a v-bind:href="authorHash.author.url" target="_blank">{{ authorHash.author.url }}</a></td>
                    <td v-if="!authorHash.status"><a v-on:click="addInfluencerAuthorFromHash(influencer.influencer.id, authorHash.author.author_id, infHash.influencer.id, 1, influencerIdx, infHashIdx, $index, authorHash.author.type)" title="Add author to monitori influencer"><span class="glyphicon glyphicon-ok"></span></a></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 text-center">
      <button v-on:click="loadMore" class="btn btn-default">Load more</button>
    </div>

  </div>
</template>

<script>
  export default {
    name: "influencers-compare",
    data() {
      return {
        limit: 20,
        offset: 0,
        filter: {
          category_id: 0
        },
        apiHost: this.$appSettings.getSetting('host'),
        influencers: [],
        category: {}
      }
    },
    methods: {
      getInfluencersCompare(limit, offset, init) {
        this.$http.get(this.apiHost + 'influencers/compare', {
          params: {
            token: this.$auth.getToken(),
            limit: limit,
            offset: offset,
            filter: this.filter
          }
        }).then(response => {
          //console.log(response);
          if (init) {
            this.influencers = response.body.data.influencers;
          } else {
            for(let influencer in response.body.data.influencers) {
              this.influencers.push(response.body.data.influencers[influencer]);
            }
          }
          this.category = response.body.data.category;
        })
      },
      loadMore() {
        this.getInfluencersCompare(this.limit, this.influencers.length, false);
      },
      setStatus(status, influencerId) {
        this.$http.post(this.apiHost + 'influencers/set/status', {
          status: status,
          influencer_id: influencerId
        }, {
          emulateJSON: true,
          headers: {
            Authorization: 'Bearer ' + this.$auth.getToken()
          },
          params: {
            token: this.$auth.getToken()
          }
        }).then(response => {
          this.getInfluencersCompare(this.influencers.length, this.offset, true);
        })
      },
      addInfluencerAuthorFromHash(influencerId, authorId, influencerHashId, status, influencerIdx, influencerHashIdx, influencerAuthorHashId, authorHashType) {
        this.$http.post(this.apiHost + 'influencers/add/author/from/hash', {
          influencer_id: influencerId,
          author_id: authorId,
          influencer_hash_id: influencerHashId,
          status: status,
          type: authorHashType
        }, {
          emulateJSON: true,
          headers: {
            Authorization: 'Bearer ' + this.$auth.getToken()
          },
          params: {
            token: this.$auth.getToken()
          }
        }).then(response => {
          if (response.body.success) {
            this.influencers[influencerIdx].authors.push(
              response.body.data
            );
            this.influencers[influencerIdx].influencerConnected[influencerHashIdx].authors[influencerAuthorHashId].status = true;
          }
        })
      },
      setAuthorStatus(id, authorId, influencerId, authorIdx, influencerIdx, status) {
        this.$http.post(this.apiHost + 'influencers/set/author/status', {
          influencer_id: influencerId,
          author_id: authorId,
          status: status,
          id: id
        }, {
          emulateJSON: true,
          headers: {
            Authorization: 'Bearer ' + this.$auth.getToken()
          },
          params: {
            token: this.$auth.getToken()
          }
        }).then(response => {
          if (response.body.success) {
            this.influencers[influencerIdx].authors[authorIdx].status = status;
          }
        })
      },
      setSimilarInfluencer(influencerId, influencerHashId, influencerIdx, influencerHashIdx) {
        console.log(influencerIdx, influencerHashIdx);
        this.$http.post(this.apiHost + 'hash/influencers/set/compare/influencer', {
          influencer_id: influencerId,
          influencer_hash_id: influencerHashId
        }, {
          emulateJSON: true,
          headers: {
            Authorization: 'Bearer ' + this.$auth.getToken()
          },
          params: {
            token: this.$auth.getToken()
          }
        }).then(response => {
          if (response.body.success) {
            this.influencers[influencerIdx].influencerConnected[influencerHashIdx].influencer.status = 2;
          }
        })
      }
    },
    created: function() {
      this.getInfluencersCompare(this.limit, this.offset, true);
    },
    computed: {
      categoryId() {
        return this.filter.category_id
      }
    },
    watch: {
      categoryId() {
        console.log('change categoryId');
        this.getInfluencersCompare(this.limit, this.offset, true);
      }
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>

  .glyphicon, .hover {
    color: #2c3e50;
    cursor: pointer;
    &:hover {
      color: #337ab7;
      span {
        color: #337ab7;
        text-decoration: underline;
      }
      .glyphicon {
        text-decoration: none;
      }
    }
  }
  .p-0 {
    padding: 0;
  }

  .m-t-10 {
    margin-top: 10px;
  }

  .m-t-20 {
    margin-top: 20px;
  }
  .border-top {
    border-top: 1px solid #ddd;
  }
  .success {
    & td {
      background-color: #dff0d8;
    }
  }
  .danger {
    & td {
      background-color: #f2dede;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/influencer/InfluencersCompare.vue